import React from "react";
import { Box, TextField, Button } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import Header from "../../../../../components/Header";
import { AssetFinanceUrl } from "../../../../../config";
import { executeAnyMutation } from "../../../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = AssetFinanceUrl.uri;

const validationSchema = yup.object().shape({
  fullName: yup.string().required("Full name is required"),
  idNumber: yup.string().required("ID/Passport number is required"),
  phoneNumber: yup.string().nullable(),
  email: yup.string().email("Enter a valid email").nullable(),
  relationship: yup.string().nullable(),
});

// props.collateralAssetId is injected by the wrapper in CoOwnerModal.jsx
const CoOwnerForm = (props) => {
  const swal = (options) =>
    Swal.fire({
      ...options,
      didOpen: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = "99999";
        options?.didOpen?.();
      },
    });

  const initialValues = {
    fullName: props.data?.FullName || "",
    idNumber: props.data?.IdNumber || "",
    phoneNumber: props.data?.PhoneNumber || "",
    email: props.data?.Email || "",
    relationship: props.data?.Relationship || "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!props.collateralAssetId) {
      swal({ icon: "error", title: "Missing asset reference", text: "Could not determine which asset this co-owner belongs to." });
      setSubmitting(false);
      return;
    }
    try {
      const payload = {
        collateralAssetId: Number(props.collateralAssetId),
        fullName: values.fullName,
        idNumber: values.idNumber,
        phoneNumber: values.phoneNumber,
        email: values.email,
        relationship: values.relationship,
      };

      const response = await executeAnyMutation(
        props.isEditing ? "updateCollateralCoOwner" : "saveCollateralCoOwner",
        props.isEditing ? { ...payload, id: Number(props.data.Id) } : payload,
        "coOwner",
        false,
        base_url,
      );

      if (response?.results) {
        props.onClose();
        props.onAction();
        swal({ icon: "success", title: "Success!", text: `Co-owner ${props.isEditing ? "updated" : "added"} successfully.` });
      } else {
        swal({ icon: "error", title: "Error!", text: response?.error || "Could not save co-owner details." });
      }
    } catch {
      swal({ icon: "error", title: "Error!", text: "An error occurred while saving. Please try again." });
    }
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Co-Owner" : "Add Co-Owner"}
        subtitle="Capture the co-owner's identifying and contact details"
      />
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize>
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="20px" gridTemplateColumns="repeat(4, minmax(0, 1fr))">
              <TextField fullWidth variant="filled" label="Full Name *" name="fullName" value={values.fullName} onChange={handleChange} onBlur={handleBlur} error={!!touched.fullName && !!errors.fullName} helperText={touched.fullName && errors.fullName} sx={{ gridColumn: "span 2" }} />
              <TextField fullWidth variant="filled" label="ID/Passport Number *" name="idNumber" value={values.idNumber} onChange={handleChange} onBlur={handleBlur} error={!!touched.idNumber && !!errors.idNumber} helperText={touched.idNumber && errors.idNumber} sx={{ gridColumn: "span 2" }} />
              <TextField fullWidth variant="filled" label="Phone Number" name="phoneNumber" value={values.phoneNumber} onChange={handleChange} onBlur={handleBlur} sx={{ gridColumn: "span 2" }} />
              <TextField fullWidth variant="filled" label="Email" name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} error={!!touched.email && !!errors.email} helperText={touched.email && errors.email} sx={{ gridColumn: "span 1" }} />
              <TextField fullWidth variant="filled" label="Relationship to Customer" name="relationship" placeholder="e.g. spouse" value={values.relationship} onChange={handleChange} onBlur={handleBlur} sx={{ gridColumn: "span 1" }} />
            </Box>
            <Box display="flex" justifyContent="flex-end" mt="24px">
              <Button type="submit" color="secondary" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? "Saving…" : props.isEditing ? "Update Co-Owner" : "Save Co-Owner"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CoOwnerForm;